import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Package, Navigation, DollarSign, User } from 'lucide-react';
import { cn } from '@/shared/utils';

const navItems = [
  { path: '/driver', icon: Home, label: 'Home', exact: true },
  { path: '/driver/orders', icon: Package, label: 'Orders', badge: 3 },
  { path: '/driver/route', icon: Navigation, label: 'Route' },
  { path: '/driver/earnings', icon: DollarSign, label: 'Earnings' },
  { path: '/driver/profile', icon: User, label: 'Profile' },
];

export const MobileBottomNav = () => {
  const location = useLocation();

  const isActive = (path, exact) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="mobile-bottom-nav mobile-safe-bottom">
      {navItems.map(({ path, icon: Icon, label, badge, exact }) => (
        <NavLink
          key={path}
          to={path}
          className={cn(
            'mobile-nav-item relative',
            isActive(path, exact) && 'mobile-nav-item-active'
          )}
        >
          <Icon className="mobile-nav-icon" />
          <span className="mobile-nav-label">{label}</span>
          {badge && badge > 0 && (
            <span className="mobile-nav-badge">{badge}</span>
          )}
        </NavLink>
      ))}
    </nav>
  );
};

export default MobileBottomNav;
